export const BASE_URL = process.env.NODE_ENV === 'development' ? 'http://localhost:8000' : 'https://api.lmplagnasetu.com';

export const MAIN_SITE_HOST = process.env.NODE_ENV === 'development' ? 'localhost:3000' : 'lmplagnasetu.com';

export const LOHANA_SITE_HOST = 'lohana.anjalavsar.com';
export const DIVORCEE_SITE_HOST = 'divorcee.anjalavsar.com';
export const NRI_SITE_HOST = 'nri.anjalavsar.com';
export const JAIN_SITE_HOST = 'jain.anjalavsar.com';
export const GORMAHARAJ_HOST = 'gormaharaj.anjalavsar.com';
export const SHAADIYOG_HOST = 'shaadiyog.in';
export const LMP_LAGNASETU_HOST = 'lmplagnasetu.com';
export const WWW_LMP_LAGNASETU_HOST = 'www.lmplagnasetu.com';
export const SAURASHTRA1_SITE_HOST = 'saurashtra1.lmplagnasetu.com';
export const SAURASHTRA2_SITE_HOST = "saurashtra2.lmplagnasetu.com";
export const SAURASHTRA3_SITE_HOST = "saurashtra3.lmplagnasetu.com";
export const SAURASHTRA4_SITE_HOST = "saurashtra4.lmplagnasetu.com";
export const KUTCH_HOST = "kutch.lmplagnasetu.com"
export const MUMBAI_SITE_HOST = "mumbai.lmplagnasetu.com"
export const MAHARASHTRA_SITE_HOST = "maharashtra.lmplagnasetu.com";
export const EASTINDIA_SITE_HOST = "eastindia.lmplagnasetu.com";
export const NORTHINDIA_SITE_HOST = "northindia.lmplagnasetu.com";

export const NORTHGUJARAT_SITE_HOST = "northgujarat.lmplagnasetu.com";
export const CENTRALGUJARAT_SITE_HOST = "centralgujarat.lmplagnasetu.com";
export const SOUTHGUJARAT_SITE_HOST = "southgujarat.lmplagnasetu.com";
export const SOUTHINDIA_SITE_HOST = "southindia.lmplagnasetu.com";
export const CENTRAL_INDIA_SITE_HOST = "centralindia.lmplagnasetu.com";
export const VIDARBHA_SITE_HOST = "vidarbha.lmplagnasetu.com";

export const EUROPE_SITE_HOST ="europe.lmplagnasetu.com";
export const GCC_SITE_HOST ="gcc.lmplagnasetu.com";
export const USA_SITE_HOST ="usa.lmplagnasetu.com";
export const AFRICA_SITE_HOST ="restofafrica.lmplagnasetu.com";
export const TANZANIA_SITE_HOST ="tanzania.lmplagnasetu.com";
export const CANADA_SITE_HOST ="canada.lmplagnasetu.com";
export const KENYA_SITE_HOST ="kenya.lmplagnasetu.com";
export const UGANDA_SITE_HOST ="uganda.lmplagnasetu.com";
export const AUSTRALIA_SITE_HOST ="australia.lmplagnasetu.com";
export const NZFIJI_SITE_HOST ="nzfiji.lmplagnasetu.com";

export const SITES = [
  // [LOHANA_SITE_HOST, 'Anjal ane Avsar Lohana'],
  // [DIVORCEE_SITE_HOST, 'Anjal ane Avsar Divorcee'],
  // [NRI_SITE_HOST, 'Anjal ane Avsar NRI'],
  // [JAIN_SITE_HOST, 'Anjal ane Avsar Jain'],
  // [SHAADIYOG_HOST, 'Shaadi Yog'],
  // [MAIN_SITE_HOST, 'Lagna setu'],
  [LMP_LAGNASETU_HOST, 'Lagna Setu'],
  // [WWW_LMP_LAGNASETU_HOST, 'Lagna Setu'],
  [SAURASHTRA1_SITE_HOST, 'Lagna Setu Saurashtra1 (Zone 1)'],
	[SAURASHTRA2_SITE_HOST, 'Lagna Setu Saurashtra2 (Zone 2)'],
	[SAURASHTRA3_SITE_HOST, 'Lagna Setu Saurashtra3 (Zone 3)'],
	[SAURASHTRA4_SITE_HOST, 'Lagna Setu Saurashtra4 (Zone 4)'],
	[KUTCH_HOST, "Lagna Setu Kutch (Zone 5)"],
	[NORTHGUJARAT_SITE_HOST, 'Lagna Setu North Gujarat (Zone 6)'],
	[CENTRALGUJARAT_SITE_HOST, 'Lagna Setu Central Gujarat (Zone 7)'],
	[SOUTHGUJARAT_SITE_HOST, 'Lagna Setu South Gujarat (Zone 8)'],
	[MUMBAI_SITE_HOST, "Lagna Setu Mumbai (Zone 9)"],
	[MAHARASHTRA_SITE_HOST, 'Lagna Setu Maharashtra (Zone 10)'],
	[CENTRAL_INDIA_SITE_HOST, 'Lagna Setu Central India (Zone 11)'],
	[VIDARBHA_SITE_HOST, 'Lagna Setu Vidarbha (Zone 12)'],
	[SOUTHINDIA_SITE_HOST, 'Lagna Setu South India (Zone 13)'],
	[EASTINDIA_SITE_HOST, 'Lagna Setu East India (Zone 14)'],
	[NORTHINDIA_SITE_HOST, 'Lagna Setu North India (Zone 15)'],
  [CANADA_SITE_HOST, 'Lagna Setu Canada (Zone 1)'],
  [USA_SITE_HOST, 'Lagna Setu USA (Zone 2)'],
  [EUROPE_SITE_HOST, 'Lagna Setu Europe And UK (Zone 3)'],
  [GCC_SITE_HOST, 'Lagna Setu GCC (Zone 4)'],
  [KENYA_SITE_HOST, 'Lagna Setu Kenya (Zone 5)'],
  [UGANDA_SITE_HOST, 'Lagna Setu Uganda (Zone 6)'],
  [TANZANIA_SITE_HOST, 'Lagna Setu Tanzania (Zone 7)'],
  [AFRICA_SITE_HOST, 'Lagna Setu Rest Of Africa (Zone 8)'],
  [AUSTRALIA_SITE_HOST, 'Lagna Setu Australia (Zone 9)'],
  [NZFIJI_SITE_HOST, 'Lagna Setu NewZealand and Fiji (Zone 10)']
];

export const INDIAN_SITES = [
  [SAURASHTRA1_SITE_HOST, 'Lagna Setu Saurashtra1 (Zone 1)'],
  [SAURASHTRA2_SITE_HOST, 'Lagna Setu Saurashtra2 (Zone 2)'],
  [SAURASHTRA3_SITE_HOST, 'Lagna Setu Saurashtra3 (Zone 3)'],
  [SAURASHTRA4_SITE_HOST, 'Lagna Setu Saurashtra4 (Zone 4)'],
  [KUTCH_HOST, "Lagna Setu Kutch (Zone 5)"],
  [NORTHGUJARAT_SITE_HOST, 'Lagna Setu North Gujarat (Zone 6)'],
  [CENTRALGUJARAT_SITE_HOST, 'Lagna Setu Central Gujarat (Zone 7)'],
  [SOUTHGUJARAT_SITE_HOST, 'Lagna Setu South Gujarat (Zone 8)'],
  [MUMBAI_SITE_HOST, "Lagna Setu Mumbai (Zone 9)"],
  [MAHARASHTRA_SITE_HOST, 'Lagna Setu Maharashtra (Zone 10)'],
  [CENTRAL_INDIA_SITE_HOST, 'Lagna Setu Central India (Zone 11)'],
  [VIDARBHA_SITE_HOST, 'Lagna Setu Vidarbha (Zone 12)'],
  [SOUTHINDIA_SITE_HOST, 'Lagna Setu South India (Zone 13)'],
  [EASTINDIA_SITE_HOST, 'Lagna Setu East India (Zone 14)'],
  [NORTHINDIA_SITE_HOST, 'Lagna Setu North India (Zone 15)'],
];

export const INTERNATIONAL_SITES = [
  [CANADA_SITE_HOST, 'Lagna Setu Canada (Zone 1)'],
  [USA_SITE_HOST, 'Lagna Setu USA (Zone 2)'],
  [EUROPE_SITE_HOST, 'Lagna Setu Europe And UK (Zone 3)'],
  [GCC_SITE_HOST, 'Lagna Setu GCC (Zone 4)'],
  [KENYA_SITE_HOST, 'Lagna Setu Kenya (Zone 5)'],
  [UGANDA_SITE_HOST, 'Lagna Setu Uganda (Zone 6)'],
  [TANZANIA_SITE_HOST, 'Lagna Setu Tanzania (Zone 7)'],
  [AFRICA_SITE_HOST, 'Lagna Setu Rest Of Africa (Zone 8)'],
  [AUSTRALIA_SITE_HOST, 'Lagna Setu Australia (Zone 9)'],
  [NZFIJI_SITE_HOST, 'Lagna Setu New Zealand and Fiji (Zone 10)']
];

export const SITE_CITY = [
  [SAURASHTRA1_SITE_HOST, "Rajkot, Morbi, Surendranagar", "Districts"],
  [SAURASHTRA2_SITE_HOST, "Jamnagar, Devbhoomi Dwarka, Porbandar", "Districts"],
  [SAURASHTRA3_SITE_HOST, "Gir Somnath, Junagadh", "Districts"],
  [SAURASHTRA4_SITE_HOST, "Bhavnagar, Amreli, Botad", "Districts"],
  [KUTCH_HOST, "Kutch", "Districts"],
  [NORTHGUJARAT_SITE_HOST, "Gandhinagar, Aravalli, Banaskantha, Mehsana, Patan, Sabarkantha", "Districts"],
  [CENTRALGUJARAT_SITE_HOST, "Ahmedabad, Vadodara, Anand, Chhota Udaipur, Dahod, Kheda, Mahisagar, Panchmahal", "Districts"],
  [SOUTHGUJARAT_SITE_HOST, "Surat, Bharuch, Dang, Narmada, Navsari, Tapi, Valsad", "Districts and UTs"],
  [MUMBAI_SITE_HOST, "Mumbai City, Mumbai Suburban", "Districts"],
  // [MUMBAI_SITE_HOST, "Churchgate to Virar (Western Line) and CST to Mulund (Central Line). Rest of area in Maharashtra Zone."],
  [MAHARASHTRA_SITE_HOST, "Thane, Palghar, Raigad, Ratnagiri, Sindhudurg, Sangli, Satara, Solapur, Kolhapur, Pune, Aurangabad, Beed, Jalna, Osmanabad, Nanded, Latur, Parbhani, Hingoli, Dhule, Jalgaon, Nandurbar, Nashik, Ahmednagar", "Districts"],
  [CENTRAL_INDIA_SITE_HOST, "Chhattisgarh, Madhya Pradesh", "States"],
  [VIDARBHA_SITE_HOST, "Akola, Amravati, Buldhana, Yavatmal, Washim, Bhandara, Chandrapur, Gadchiroli, Gondia, Nagpur, Wardha", "Districts"],
  [SOUTHINDIA_SITE_HOST, "Goa, Karnataka, Andhra Pradesh, Telangana, Kerala, Tamil Nadu, Andaman and Nicobar Islands, Lakshadweep, Puducherry", "States and UTs"],
  [EASTINDIA_SITE_HOST, "Bihar, Jharkhand, Odisha, West Bengal, Arunachal Pradesh, Assam, Manipur, Meghalaya, Mizoram, Nagaland, Sikkim, Tripura", "States and UTs"],
  [NORTHINDIA_SITE_HOST, "Jammu and Kashmir, Ladakh, Delhi, Chandigarh, Haryana, Himachal Pradesh, Punjab, Rajasthan, Uttarakhand, Uttar Pradesh", "States and UTs"],
  [CANADA_SITE_HOST, "All areas of Canada including Shree Lohana Mahaparishad's regions of Toronto, Vancouver and Calgary","Areas"],
  [USA_SITE_HOST, "All areas of the United States of America including Shree Lohana Mahaparishad's regions of Los Angeles, Mid West, West Coast and East Coast","Areas"],
  [EUROPE_SITE_HOST, "England, Scotland & Wales, Albania, Andorra, Armenia, Austria, Azerbaijan, Belarus, Belgium, Bosnia-Herzegovina, Bulgaria, Croatia, Czech Republic, Denmark, Estonia, Finland, France, Georgia, Germany, Greece, Hungary, Iceland, Ireland, Italy, Kosovo, Latvia, Liechtenstein, Lithuania, Luxembourg, Macedonia, Malta, Moldova, Monaco, Montenegro, Netherlands, Norway, Poland, Portugal, Romania, Russia, San Marino, Serbia, Slovakia, Slovenia, Spain, Sweden, Switzerland, Turkey, Ukraine, United Kingdom (England, Northern Ireland, Scotland, Wales), Vatican City", 'Countries'],
  [GCC_SITE_HOST, "Saudi Arabia, Kuwait, United Arab Emirates, Qatar, Bahrain, and Oman and other countries in Middle East", "Countries"],
  [KENYA_SITE_HOST, "All areas of Kenya including Shree Lohana Mahaparishad's regions of Nairobi, Nakuru, Kisumu, Mombasa", "Areas"],
  [UGANDA_SITE_HOST, "All areas of Uganda including Shree Lohana Mahaparishad's regions of  Kampala and Jinja", "Areas"],
  [TANZANIA_SITE_HOST, "All areas of Tanzania including Shree Lohana Mahaparishad's regions of Dar-es-Salaam and Arusha", "Areas"],
  [AFRICA_SITE_HOST, "All areas in Africa excluding the countries of Kenya, Uganda and Tanzania", "Areas"],
  [AUSTRALIA_SITE_HOST, "All areas in Australia", "Areas"],
  [NZFIJI_SITE_HOST, "All areas in New Zealand and Fiji", "Areas"],
  ["localhost:3000", "Rajkot, Morbi, Surendranagar"]
];


export const OLD_LOGIN_DISABLED = [
  SHAADIYOG_HOST,
];

export const FB_APP_ID = process.env.NODE_ENV === 'development' ? '1888483423' : '7107631354';

export const GOOGLE_APP_ID = process.env.NODE_ENV === 'development' ? '1047681934266-oo8b45ananrqtid2ictql0j8vstb53mf.apps.googleusercontent.com' : '402814005636-2j6hfdgvdu04cqbo4dnsoi5vu2igdq7i.apps.googleusercontent.com';

console.log('+++GOOGLE_APP_ID', GOOGLE_APP_ID);

export const SECTION_STEPS = {
  basicinfo: 'step-1',
  personalinfo: 'step-2',
  // lifestyleinfo: 'step-3',
  educationinfo: 'step-3',
  familyinfo: 'step-4',
  // contactinfo: 'step-5',
  referenceinfo: 'step-5',
  photos: 'step-6',
  // pdfs: 'step-8',
  idproof: 'step-7',
};

export const COMPLETE_PROFILE_TITLES = {
  'step-1': 'Step 1 of 7 - Account Information',
  'step-2': 'Step 2 of 7 - Personal Profile',
  // 'step-3': 'Step 3 of 10 - Your Lifestyle & Health',
  'step-3': 'Step 3 of 7 - Education & Work',
  'step-4': 'Step 4 of 7 - Family & Residence',
  // 'step-5': 'Step 5 of 7 - Contact Info',
  'step-5': 'Step 5 of 7 - Reference Info',
  'step-6': 'Step 6 of 7 - Upload Photos',
  // 'step-8': 'Step 8 of 7 - Upload Bio Data',
  'step-7': 'Step 7 of 7 - Upload Identity Proof',
};


export const STEP_SECTIONS = {
  'step-1': 'basicinfo',
  'step-2': 'personalinfo',
  // 'step-3': 'lifestyleinfo',
  'step-3': 'educationinfo',
  'step-4': 'familyinfo',
  // 'step-5': 'contactinfo',
  'step-5': 'referenceinfo',
  'step-6': 'photos',
  // 'step-8': 'pdfs',
  'step-7': 'idproof',
};


export const SECTION_TITLES = {
  basicinfo: 'Account Information',
  personalinfo: 'Edit Personal Info',
  lifestyleinfo: 'Your Lifestyle & Health',
  educationinfo: 'Education & Work',
  familyinfo: 'Family Info',
  contactinfo: 'Contact Info',
  referenceinfo: 'Reference Info',
  photos: 'Upload Photos',
  pdfs: 'Upload Bio Data',
  idproof:'Upload Identity Proof',
  partnerchoice: 'Partner\'s Choice',
};


export const SEARCH_FILTERS = {
  from_age: 'From age',
  to_age: 'To age',
  from_height: 'From height',
  to_height: 'To height',
  marital_status: 'Marital Status',
  profession: 'Profession',
  work_profile: 'Work Profile',
  caste: 'Caste',
  qualification: 'Qualification',
  study_field: 'Study Field',
  degree: 'Degree',
  income: 'Income',
  from_india: 'Candidates Living in India?',
  country: 'Country',
  city: 'Country',
  bureau: 'Bureau',
  is_premium: 'Show Gor Maharaj (premium) profiles',
};


export const CSS_FILES = {
  'localhost:3000': null,
  'anjalavsar.com': null,
};


export const LOGO_FILES = {
  'localhost:3000': 'main.png',
  'anjalavsar.com': 'main.png',
};


export const COVER_FILES = {
  'localhost:3000': 'back2.jpg',
  'anjalavsar.com': 'back2.jpg',
};


export const DEFAULT_ERROR = 'Something went wrong! Please reload your page. If it still does not work, then please contact at support@anjalavsar.com';



// WEBPACK FOOTER //
// ./src/config/constants.js